"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTaskTarget = useTaskTarget;
var react_1 = require("react");
function useTaskTarget() {
    var _a = (0, react_1.useState)(null), task = _a[0], setTask = _a[1];
    var open = (0, react_1.useCallback)(function (target) { return setTask(target); }, []);
    var close = (0, react_1.useCallback)(function () { return setTask(null); }, []);
    return { task: task, open: open, close: close };
}
